/** App\Enums\FeedbackStatus */
export enum FeedbackStatus {
  Action = 'action',
  NeedsInternalReview = 'needs_internal_review',
  NeedsClientReview = 'needs_client_review',
  Revise = 'revise',
  Disregard = 'disregard',
  Completed = 'completed',
  RequestForAdditionalInformation = 'request_for_additional_information',
}
